import dayjs from 'dayjs';

export const providers = [
  'pragmatic',
  'netent',
  'playngo',
  'evoplay',
  'gameart',
  'platipus',
  'betsoft',
  'amatic',
  'wazdan',
  'playson',
  'quickspin',
  'bsw',
  'playtech',
  'dlv',
  'fishing',
  'endorphina',
  'merkur',
  'kajot',
  'wacs',
  'gaminator',
  'mrslotty',
  'igt',
  'greentube',
  'aristocrat',
  'apollo',
  'inbet',
  'konami',
  'austria',
  'flg',
  'cqgaming',
  'relaxgaming',
  'booongo',
  'igrosoft',
  'nolimit',
  'wmg',
  'elbet',
  'redrake',
  'spribe',
  'pragmaticlive',
  'evolutionlive',
  'pragmaticlive',
  'tvbet',
  'xpg',
  'goldenrace',
  'universalrace',
];

export const daysFilterValue = [
  {
    text: 'today',
    value: new Date(dayjs().startOf('day').toDate()),
    value2: new Date(dayjs().startOf('day').add(1, 'day').toDate()), // start next day
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().subtract(1, 'day').startOf('day').toDate()),
    value2: new Date(dayjs().subtract(1, 'day').startOf('day').add(1, 'day').toDate()),
  },
  {
    text: 'currentWeek',
    value: new Date(dayjs().startOf('day').day(1).toDate()), // Monday 00:00
    value2: new Date(dayjs().startOf('day').day(1).add(7, 'day').toDate()), // next Monday 00:00 (semi-open)
  },
  {
    text: 'currentMonth',
    value: new Date(dayjs().startOf('month').toDate()),
    value2: new Date(dayjs().startOf('month').add(1, 'month').toDate()), // start next month
  },
  {
    text: 'lastWeek',
    value: new Date(dayjs().startOf('day').day(1).subtract(1, 'week').toDate()),
    value2: new Date(dayjs().startOf('day').day(1).subtract(1, 'week').add(7, 'day').toDate()),
  },
  {
    text: 'lastMonth',
    value: new Date(dayjs().subtract(1, 'month').startOf('month').toDate()),
    value2: new Date(dayjs().startOf('month').toDate()), // start of current month
  },
];

export const generalReportDaysFilterValue = [
  {
    text: 'today',
    value: new Date(dayjs().startOf('day').toDate()),
    value2: new Date(dayjs().startOf('day').toDate()),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().subtract(1, 'day').startOf('day').toDate()),
    value2: new Date(dayjs().subtract(1, 'day').startOf('day').toDate()),
  },
  {
    text: 'last7Days',
    value: new Date(dayjs().subtract(6, 'day').startOf('day').toDate()),
    value2: new Date(dayjs().startOf('day').toDate()),
  },
  {
    text: 'last30Days',
    value: new Date(dayjs().subtract(29, 'day').startOf('day').toDate()),
    value2: new Date(dayjs().startOf('day').toDate()),
  },
  {
    text: 'currentMonth',
    value: new Date(dayjs().startOf('month').toDate()),
    value2: new Date(dayjs().startOf('day').toDate()),
  },
  {
    text: 'lastMonth',
    value: new Date(dayjs().subtract(1, 'month').startOf('month').toDate()),
    value2: new Date(dayjs().subtract(1, 'month').endOf('month').startOf('day').toDate()),
  },
];

export const diffRangeItems = {
  today: [
    { name: 'precedingDay', value: { count: 1, type: 'day' } },
    { name: 'sameDayLastWeek', value: { count: 1, type: 'week' } },
    { name: 'sameDayLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  yesterday: [
    { name: 'precedingDay', value: { count: 1, type: 'day' } },
    { name: 'sameDayLastWeek', value: { count: 1, type: 'week' } },
    { name: 'sameDayLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  currentWeek: [
    { name: 'precedingWeek', value: { count: 1, type: 'week' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'sameWeekLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  last7Days: [
    { name: 'precedingPeriod', value: { count: 7, type: 'day' } },
    { name: 'samePeriodLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  last30Days: [
    { name: 'precedingPeriod', value: { count: 30, type: 'day' } },
    { name: 'samePeriodLastMonth', value: { count: 1, type: 'month' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  currentMonth: [
    { name: 'precedingMonth', value: { count: 1, type: 'month' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],

  lastWeek: [
    { name: 'precedingWeek', value: { count: 1, type: 'week' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  lastMonth: [
    { name: 'precedingMonth', value: { count: 1, type: 'month' } },
    { name: 'fourWeeksAgo', value: { count: 4, type: 'week' } },
    { name: 'manualCompare', value: 'manualCompare' },
  ],
  manualCompare: [{ name: 'manualCompare', value: 'manualCompare' }],
};

export const daysFilterValueMobile = [
  {
    text: 'today',
    value: new Date(dayjs().add(0, 'day')),
    value2: new Date(dayjs().add(1, 'day')),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().add(-1, 'day')),
    value2: new Date(dayjs().add(0, 'day')),
  },
  {
    text: 'lastWeek',
    value: new Date(dayjs().add(-(dayjs().day() + 7 - 1), 'day')),
    value2: new Date(dayjs().add(-(dayjs().day() + 0 - 1), 'day')),
  },
];

export const structure = [
  {
    name: 'allUsers',
    value: 'allUsers',
  },
  {
    name: 'directOnly',
    value: 'directOnly',
  },
];

export const searchInItems = [
  {
    name: 'agent',
    value: '6',
  },
  {
    name: 'user',
    value: '0',
  },
];

export const providerItems = [
  {
    name: 'all',
    value: '',
  },
  {
    name: 'AJUSTE DE GANANCIA',
    value: 'Ajuste de ganancia',
  },
  {
    name: 'PRAGMATIC-SLOTS',
    value: 'PRAGMATIC-SLOTS',
  },
  {
    name: 'PRAGMATIC-LIVE-CASINO',
    value: 'PRAGMATIC-LIVE-CASINO',
  },
  {
    name: 'PRAGMATIC-BJ',
    value: 'PRAGMATIC-BJ',
  },
  {
    name: 'REDRAKE',
    value: 'REDRAKE',
  },
  {
    name: 'OUTCOMEBET',
    value: 'OUTCOMEBET',
  },
  {
    name: 'HACKSAW',
    value: 'HACKSAW',
  },
  {
    name: 'EVOPLAY',
    value: 'EVOPLAY',
  },
  //{
  //  name: 'EVOLUTION',
  //  value: 'EVOLUTION',
  // },
  {
    name: 'TVBET',
    value: 'TVBET',
  },
  {
    name: 'JACKTOP',
    value: 'JACKTOP',
  },
  {
    name: 'PGSOFT',
    value: 'PGSOFT-ORIGINAL',
  },
  {
    name: 'AMIGOGAMING',
    value: 'AMIGOGAMING',
  },
  {
    name: 'UPGAMING',
    value: 'UPGAMING',
  },
  {
    name: 'SMARTSOFT',
    value: 'SMARTSOFT',
  },
  {
    name: 'GALAXSYS',
    value: 'GALAXSYS',
  },
  {
    name: 'MASCOT',
    value: 'MASCOT',
  },
  //{
  //  name: 'FIABLE',
  //   value: 'FIABLE',
  //},
  //{
  // name: 'BSWGAMES',
  // value: 'BSWGAMES',
  //},
  //{
  //  name: 'INBET',
  //  value: 'INBET',
  // },
  {
    name: 'KAGAMING',
    value: 'KAGAMING',
  },
  {
    name: 'BGAMING',
    value: 'BGAMING',
  },
  //{
  //  name: 'RGS',
  //  value: 'RGS',
  //},
  {
    name: 'ULTIM8',
    value: 'GR8',
  },
  //{
  //  name: 'SOFTGAMING',
  //  value: 'SOFTGAMING',
  // },
  {
    name: 'SLOTEGRATOR',
    value: 'SLOTEGRATOR',
  },
  {
    name: 'UNIVERSALRACE',
    value: 'UNIVERSALRACE',
  },
  {
    name: 'AMUSNET',
    value: 'AMUSNET',
  },
  {
    name: '123SLOTS',
    value: '123SLOTS',
  },
  {
    name: 'EGT',
    value: 'EGT',
  },
  // {
  //  name: 'BETRADAR',
  //  value: 'BETRADAR',
  // },
  // {
  //  name: 'LINE1X',
  //  value: 'LINE1X',
  // },
  //{
  //  name: 'FLG',
  //  value: 'FLG',
  // },
  {
    name: 'EZUGI',
    value: 'EZUGI',
  },
  {
    name: 'BELATRA',
    value: 'BELATRA',
  },
  {
    name: 'PLATIPUS',
    value: 'PLATIPUS',
  },
  {
    name: 'VIVOGAMING',
    value: 'VIVOGAMING',
  },
  {
    name: 'BETONGAMES',
    value: 'BETONGAMES',
  },
  {
    name: 'WINFINITY-SLOTS',
    value: 'WINFINITY-SLOTS',
  },
  {
    name: 'WINFINITY-LIVE-CASINO',
    value: 'WINFINITY-LIVE-CASINO',
  },
  {
    name: '18PEACHES',
    value: '18PEACHES',
  },
  {
    name: 'ENDORPHINA',
    value: 'ENDORPHINA',
  },
  {
    name: 'Poly Trade',
    value: 'GAMMATRADE',
  },
];

export const statusBets = [
  {
    name: 'win',
    value: 1,
  },
  {
    name: 'bet',
    value: 2,
  },
  {
    name: 'refund',
    value: 3,
  },
];

export const statusSportBets = [
  {
    name: 'wait',
    value: 2,
  },
  {
    name: 'win',
    value: 1,
  },
  {
    name: 'return',
    value: 3,
  },
  // {
  //   name: 'loss',
  //   value: 4,
  // },
  // {
  //   name: 'sold',
  //   value: 5,
  // },
];

export const gameTypes = [
  {
    name: 'all',
    value: 'all',
  },
  {
    name: 'slots',
    value: 'slots',
  },
  {
    name: 'liveCasino',
    value: 'live-casino',
  },
  // {
  //   name: 'fiable',
  //   value: 'fiable',
  // },
];

export const sortFieldsForMobile = ['provider', 'betAmount', 'winAmount', 'betCount', 'incomeAmount'];

export const generalReportMetrics = [
  { key: 'betCount', metric: 'bets_count', label: 'totalBetCount', currency: false },
  { key: 'betAmount', metric: 'total_bets', label: 'totalBet', currency: true },
  { key: 'winAmount', metric: 'total_win', label: 'totalWon', currency: true },
  { key: 'incomeAmount', metric: 'total_netwin', label: 'netwin', currency: true },
  { key: 'commissionBalance', metric: 'commission', label: 'commissionBalance', currency: true },
  { key: 'margin', metric: 'margin', label: 'margin', suffix: '%' },
  { key: 'activeUsers', metric: 'active_users', label: 'activeUsers', currency: false },
  { key: 'rtp', metric: 'rtp', label: 'rtp', suffix: '%' },
];

export const providerScheduleMetrics = [
  { key: 'bets_count', label: 'numberOfBets' },
  { key: 'total_bets', label: 'totalBets' },
  { key: 'total_win', label: 'totalWinnings' },
  { key: 'total_netwin', label: 'netwin' },
];

export const DAY_MILLISECONDS = 86_400_000;
